import React, { useState } from "react";
import { Button, Column, Input, Modal, Row, Text } from "@amzn/meridian";

interface ManualBarcodeEntryModalProps {
  open: boolean;
  onSubmit: (barcode: string) => void;
  onClose: () => void;
}

const ManualBarcodeEntryModal: React.FC<ManualBarcodeEntryModalProps> = ({
  open,
  onSubmit,
  onClose,
}) => {
  const [barcodeInput, setBarcodeInput] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    const trimmed = barcodeInput.trim();

    if (!trimmed) {
      setError("Please enter a barcode");
      return;
    }

    onSubmit(trimmed);
    setBarcodeInput("");
    setError("");
  };

  const handleClose = () => {
    setBarcodeInput("");
    setError("");
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose} title="Enter Barcode Manually"
    scrollContainer="modal">
      <Column spacing="400" spacingInset="500">
        <Text type="b200" color="secondary">
          Type the barcode value printed on the container label.
        </Text>

        <Input
          value={barcodeInput}
          onChange={(value: string) => { setBarcodeInput(value); setError(""); }}
          placeholder="e.g. HAZ-12345"
        />

        {error && (
          <Text type="b200" color="error">
            {error}
          </Text>
        )}

        <Row alignmentHorizontal="end" spacing="300">
          <Button type="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button type="primary" onClick={handleSubmit} disabled={!barcodeInput.trim()}>
            Add Barcode
          </Button>
        </Row>
      </Column>
    </Modal>
  );
};

export default ManualBarcodeEntryModal;
